import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';
import ChartDownloadButton from './ChartDownloadButton';
import Model from './Model';
import { FiInfo } from 'react-icons/fi';
import { isEmpty } from 'lodash';
import LineChartBody from './LineChartBody';

const Legend = ({ data, chartRef }) => {
  const handleLegendToggle = name => {
    chartRef.current.getEchartsInstance().dispatchAction({
      type: 'legendToggleSelect',
      name
    });
  };

  return (
    <Col xs="auto" className="d-flex">
      {data?.map((category, index) => (
        <Form.Check
          key={index}
          type="checkbox"
          id={`vegitationSeries${category}`}
          className="mb-0 d-flex"
        >
          <Form.Check.Input
            type="checkbox"
            className={classNames({
              'form-check-input-primary': index === 0,
              'ms-2 form-check-input-warning opacity-75': index === 1
            })}
            onClick={() => handleLegendToggle(category)}
            defaultChecked
          />
          <Form.Check.Label className="ps-2 fs--2 text-600 mb-0">
            <span className="text-dark">{category}</span>
          </Form.Check.Label>
        </Form.Check>
      ))}
    </Col>
  );
};

const LineChartComponent = ({ data }) => {
  const Chartdata = data;

  const extractChartData = Chartdata => {
    const chartValues = Object.values(get(Chartdata, 'data', {}));
    const xAxis = get(Chartdata, 'series', []);
    const series = Object.keys(get(Chartdata, 'data', {}));
    const unit = Chartdata?.unit || '';

    // Returning in the required format
    return {
      data: chartValues,
      xAxis: xAxis,
      Series: series,
      label: 2,
      unit: unit
    };
  };

  const Data = extractChartData(Chartdata);
  const chartRef = useRef(null);
  const seriesColors = ['success', 'danger', 'info', 'warning', 'primary'];
  const [showModal, setShowModal] = useState(false);
  const [selectedLegend, setSelectedLegend] = useState(null);
  const [desc, setDesc] = useState('');

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleLegendSelect = legend => {
    setSelectedLegend(legend);
    setDesc(Chartdata.info[legend] || '');
  };

  return (
    <Card className="h-100 overflow-hidden">
      <FalconCardHeader
        title={Chartdata?.label}
        titleTag="h5"
        light={true}
        desc={Chartdata?.desc}
        endEl={
          <ChartDownloadButton
            chartData={Data.data}
            xAxis={Data.xAxis}
            series={Data.Series}
            filename={`${Chartdata?.label}`}
          />
        }
        infoBtn={
          !isEmpty(Chartdata?.description) && (
            <FiInfo onClick={handleShowModal} />
          )
        }
      />
      <Card.Body className="h-100 px-3" dir="ltr">
        <LineChartBody
          chartdata={Data}
          label={Chartdata?.label}
          onLegendSelect={handleLegendSelect}
        />
      </Card.Body>
      <Card.Footer className="bg-white py-2 card-footer-style">
        {desc ? (
          <h5 className="infrence-info">
            {selectedLegend}: {desc}
          </h5>
        ) : (
          <></>
        )}
      </Card.Footer>
      <Model
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        description={Chartdata?.description}
        title={Chartdata?.label}
      />
    </Card>
  );
};

Legend.propTypes = {
  chartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  data: PropTypes.arrayOf(PropTypes.string)
};

LineChartComponent.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.number)
      })
    ),
    date: PropTypes.arrayOf(PropTypes.string).isRequired,
    info: PropTypes.string,
    label: PropTypes.string.isRequired,
    unit: PropTypes.string.isRequired
  })
};

export default LineChartComponent;
